// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__n1pa2","consentsList":"PatientConsents_consentsList__2muWc","consentsListEmpty":"PatientConsents_consentsListEmpty__3CsUQ"};